import React, { Component } from 'react';
import { Breadcrumb, Button, Divider, Modal, Select, message } from 'antd';
import { ACTION_STATUS } from '../../../../../utils/ActionStatus';
import RuleMasterGrid from './RuleMasterGrid';
import AddOrEditRuleMasterModalDialog from './AddOrEditRuleMasterModalDialog';
import OperationRecordDialog from '../../../common/operationRcd/components/OperationRecordDialog';
import '../../FundMonitoring.css';

class RuleMasterDashboard extends Component {
    componentDidMount() {
        if (!this.props.countryCodeDOArray || this.props.countryCodeDOArray.length === 0) {
            this.props.loadCountryCodes();
        }
        this.props.loadRuleMaster();
    }

    componentDidUpdate() {
        const {
            loadRuleMasterActionStatus,
            loadRuleMasterActionResp,
            deleteRuleMasterActionStatus,
            deleteRuleMasterActionResp,
        } = this.props;

        if (loadRuleMasterActionStatus === ACTION_STATUS.SUCCESS) {
            this.props.initLoadRuleMasterActionStatus();
        }
        if (loadRuleMasterActionStatus === ACTION_STATUS.ERROR) {
            const errMsg = loadRuleMasterActionResp && loadRuleMasterActionResp.respMessage
                ? loadRuleMasterActionResp.respMessage
                : 'Query Rule Master failed.';
            message.error(errMsg);
            this.props.initLoadRuleMasterActionStatus();
        }
        if (deleteRuleMasterActionStatus === ACTION_STATUS.SUCCESS) {
            message.success('Delete Rule Master succeeded.');
            this.props.initDeleteRuleMasterActionStatus();
            this.props.loadRuleMaster();
        }
        if (deleteRuleMasterActionStatus === ACTION_STATUS.ERROR) {
            const errMsg = deleteRuleMasterActionResp && deleteRuleMasterActionResp.respMessage
                ? deleteRuleMasterActionResp.respMessage
                : 'Delete Rule Master failed.';
            message.error(errMsg);
            this.props.initDeleteRuleMasterActionStatus();
        }
    }

    onQueryInputChange = ({ name, value }) => {
        this.props.ruleMasterQueryInputChange({ name, value });
    };

    searchBtnOnClicked = () => {
        if (this.props.ruleMasterGrid && this.props.ruleMasterGrid.api) {
            this.props.ruleMasterGrid.api.deselectAll();
        }
        this.onQueryInputChange({ name: 'showAll', value: false });
        this.props.loadRuleMaster();
    };

    showAllBtnOnClicked = () => {
        const { showAll } = this.props.ruleMasterQueryFields;
        this.onQueryInputChange({ name: 'showAll', value: !showAll });
    };

    addOrEditBtnOnClicked = mode => {
        const { selectedRuleMasterArray } = this.props;
        if (mode === 'ADD') {
            this.props.openAddOrEditRuleMasterModal(mode, null);
            return;
        }
        if (selectedRuleMasterArray.length !== 1) {
            message.warning('Please choose one and only one Rule.');
            return;
        }
        this.props.openAddOrEditRuleMasterModal(mode, selectedRuleMasterArray[0]);
    };

    deleteBtnOnClicked = () => {
        const { selectedRuleMasterArray } = this.props;
        if (selectedRuleMasterArray.length === 0) {
            message.warning('Please choose at least one Rule.');
            return;
        }
        Modal.confirm({
            title: 'Delete Rule Master',
            content: 'Are you sure you want to delete the selected rule(s)?',
            okText: 'Delete',
            okType: 'danger',
            onOk: () => this.props.deleteRuleMaster(selectedRuleMasterArray),
        });
    };

    opRcdCustomColumns = ['operator', 'operateTime', 'dataId', 'operateType', 'comments', 'before', 'after'];

    operationRecordBtnOnClicked = () => {
        const { selectedRuleMasterArray } = this.props;
        const queryFields = { module: 'RuleMaster' };
        if (selectedRuleMasterArray && selectedRuleMasterArray.length > 0) {
            queryFields.dataId = selectedRuleMasterArray.map(item => item.id).join(',');
        }
        this.props.doOperationRecordAction({
            action: 'OPEN_AND_QUERY',
            queryFields,
            customColumns: this.opRcdCustomColumns,
        });
    };

    render() {
        const {
            categoryOptions,
            fundOptions,
            loadRuleMasterActionStatus,
            deleteRuleMasterActionStatus,
        } = this.props;

        const {
            category,
            fund,
            showAll,
        } = this.props.ruleMasterQueryFields;

        const queryLoading = loadRuleMasterActionStatus === ACTION_STATUS.LOGINING;
        const deleteLoading = deleteRuleMasterActionStatus === ACTION_STATUS.LOGINING;

        return (
            <div className="ruleMasterWrapper">
                <div className="breadcrumbWrapper">
                    <Breadcrumb>
                        <Breadcrumb.Item>Fund Monitoring</Breadcrumb.Item>
                        <Breadcrumb.Item>Rule Master</Breadcrumb.Item>
                    </Breadcrumb>
                </div>
                <div className="operationBar">
                    <Select
                        allowClear
                        showSearch
                        size="small"
                        placeholder="Rule Category"
                        value={category}
                        style={{ width: 170, marginLeft: 10 }}
                        onChange={value => this.onQueryInputChange({ name: 'category', value })}
                    >
                        {categoryOptions}
                    </Select>
                    <Select
                        allowClear
                        showSearch
                        size="small"
                        placeholder="Fund"
                        value={fund}
                        style={{ width: 150, marginLeft: 10 }}
                        onChange={value => this.onQueryInputChange({ name: 'fund', value })}
                    >
                        {fundOptions}
                    </Select>
                    <Button
                        type="primary"
                        onClick={this.searchBtnOnClicked}
                        loading={queryLoading}
                        style={{ fontSize: 16, marginLeft: 10 }}
                        size="small"
                        icon="search"
                    />
                    <Button
                        onClick={this.showAllBtnOnClicked}
                        size="small"
                        type={showAll ? 'primary' : 'default'}
                        style={{ marginLeft: 10 }}
                    >
                        Show All
                    </Button>

                    <Divider type="vertical" />

                    <Button
                        onClick={() => this.addOrEditBtnOnClicked('ADD')}
                        size="small"
                        className="positive-button"
                    >
                        Add
                    </Button>
                    <Button
                        onClick={() => this.addOrEditBtnOnClicked('EDIT')}
                        size="small"
                        style={{ marginLeft: 10 }}
                        type="primary"
                    >
                        Edit
                    </Button>
                    <Button
                        onClick={() => this.addOrEditBtnOnClicked('COPY')}
                        size="small"
                        style={{ marginLeft: 10 }}
                        className="positive-button"
                    >
                        Copy
                    </Button>
                    <Button
                        onClick={this.deleteBtnOnClicked}
                        loading={deleteLoading}
                        size="small"
                        style={{ marginLeft: 10 }}
                        className="negative-button"
                    >
                        Del
                    </Button>

                    <Divider type="vertical" />

                    <Button
                        onClick={this.operationRecordBtnOnClicked}
                        size="small"
                        type="primary"
                    >
                        Operation Record
                    </Button>
                </div>

                <div className="ruleMasterGrid">
                    <RuleMasterGrid {...this.props} />
                </div>
                <AddOrEditRuleMasterModalDialog {...this.props} />
                <OperationRecordDialog {...this.props} />
            </div>
        );
    }
}

export default RuleMasterDashboard;
